
        import Symbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-cadaster-pkk",
  "use": "icon-cadaster-pkk-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 50 50\" id=\"icon-cadaster-pkk\"><g clip-path=\"url(#icon-cadaster-pkk_a)\"><g fill=\"#fff\" clip-path=\"url(#icon-cadaster-pkk_b)\"><path d=\"M23.798 19.06H12.89v10.912h10.908zM12.894 15.424h10.908V4.516c-5.936.172-10.732 4.968-10.908 10.908M12.886 44.516c5.936-.176 10.732-4.972 10.908-10.908H12.886zM27.438 4.516v10.912h10.908c-.176-5.944-4.972-10.74-10.908-10.912M27.438 29.972C33.374 29.796 38.17 25 38.346 19.06H27.438z\" /></g></g><defs><clipPath id=\"icon-cadaster-pkk_a\"><path fill=\"#fff\" d=\"M0 0h64v64H0z\" /></clipPath><clipPath id=\"icon-cadaster-pkk_b\"><path fill=\"#fff\" d=\"M0 0h64v64H0z\" /></clipPath></defs></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-cadaster-pkk"/>
                </svg>
            );
        };

        Icon.id = "icon-cadaster-pkk";

        export default Icon;
    